import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Button } from "@material-ui/core";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import BarChartIcon from "@material-ui/icons/BarChart";
import Snackbar from "../snackbar";
import { styles } from "./style";
import Loading from "../loading";
import SimpleLineChart from "./lineChart";
import ToolbarEmotion from "./toolbarEmotion";
import ToolbarChart from "./toolbarChart";
import Emotion from "./emotion";
import ListInteract from "./listInteract";
import Header from "../../partials/header";

let to = moment().endOf("month").valueOf();
let from = moment().subtract(3, "months").startOf("month").valueOf();
export class NPS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthBegin: 0,
      yearBegin: 0,
      totalInteract: 0,
      totalEmotion: 0,
      dataChart: [],
      dataEmotion: {
        angry: 0,
        sad: 0,
        normal: 0,
        happy: 0,
        love: 0,
      },
      show: "chart",
    };
  }
  async componentDidMount() {
    this.getDataForChart({ from: from, to: to });
    this.getDataForEmotion({ from: from, to: to });
    this.props.serviceBranchDispatch.getListBranch();
  }
  getDataForEmotion = async (payload = {}) => {
    this.loading.startLoading();
    if (payload.from)
      payload.from = moment(payload.from).startOf("month").valueOf();
    if (payload.to) payload.to = moment(payload.to).endOf("month").valueOf();
    let check = await this.props.npsDispatch.get(payload);
    this.loading.stopLoading();
    if (check.code === 1) {
      let values = Object.values(check.data);
      let totalEmotion = values.reduce((a, b) => a + b, 0);
      this.setState({
        dataEmotion: {
          angry: check.data.angry || 0,
          sad: check.data.sad || 0,
          normal: check.data.normal || 0,
          happy: check.data.happy || 0,
          love: check.data.love || 0,
        },
        totalEmotion: totalEmotion,
      });
    } else {
      this.mSnackbar.handleClick(check.message, "error");
    }
  };
  changeEmotion = (data = {}) => {
    let from = moment(data.from).startOf("month").valueOf();
    let to = moment(data.to).endOf("month").valueOf();
    this.getDataForEmotion({ from: from, to: to, branchCode: data.branchCode });
  };
  changeChart = (branchCode, typeEmotion, date) => {
    date = moment(date);
    let to = new Date(date.year(), date.month() + 1, 0);
    let intervalMonth = 3;
    let monthBegin = date.subtract(intervalMonth, "months").month() + 1;
    let yearBegin = date.subtract(intervalMonth, "month").year();

    let from = new Date(yearBegin, monthBegin, 1);
    // this.date = to;
    this.getDataForChart({
      from: from,
      to: to,
      emotion: typeEmotion,
      branchCode: branchCode,
    });
    this.setState({ monthBegin: monthBegin, yearBegin: yearBegin });
  };
  getDataForChart = async (payload) => {
    this.loadingChart.startLoading();
    if (payload.from)
      payload.from = moment(payload.from).startOf("month").valueOf();
    if (payload.to) payload.to = moment(payload.to).endOf("month").valueOf();
    let check = await this.props.npsDispatch.getDataForChart(payload);
    this.loadingChart.stopLoading();
    if (check.code === 1) {
      let data = [];
      let list = check.data;
      let totalInteract = 0;
      list.map((ele, index) => {
        let emotion = ele._id.emotion;
        totalInteract += ele.count;
        let check = data.findIndex(
          (e) => e.year === ele._id.year && e.month === ele._id.month
        );
        // if(ele)
        if (check === -1) {
          data.push({
            time: ele._id.month + "/" + ele._id.year,
            year: ele._id.year,
            month: ele._id.month,
            [emotion]: ele.count,
          });
        } else {
          data[check][emotion] = ele.count;
        }
      });
      this.setState({ dataChart: data, totalInteract: totalInteract });
    } else {
      this.mSnackbar.handleClick(check.message, "error");
    }
  };
  handleChange = (event, newStatus) => {
    this.setState({ show: newStatus });
  };
  handleButton = (button) => {
    this.setState({ show: button });

    if (button === "chart") {
      this.getDataForChart({ from: from, to: to });
      this.getDataForEmotion({ from: from, to: to });
    }
  };
  handleFilterDate = (from, to) => {
    this.ListInteract.handleFilterDate({ from: from, to: to });
  };
  render() {
    const { t, classes } = this.props;
    let {
      dataEmotion,
      dataChart,
      totalInteract,
      totalEmotion,
      show,
    } = this.state;
    const renderActionCustom = () => {
      return (
        <div className={classes.containerButton}>
          <Button
            className={
              show === "chart" ? classes.buttonActive : classes.buttonNonActive
            }
            onClick={() => this.handleButton("chart")}
            size="small"
            variant="contained"
          >
            <BarChartIcon />
          </Button>
          <Button
            className={
              show === "list" ? classes.buttonActive : classes.buttonNonActive
            }
            onClick={() => this.handleButton("list")}
            size="small"
            variant="contained"
          >
            <FormatListBulletedIcon />
          </Button>
        </div>
      );
    };
    return (
      <div>
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Header
          session={t("CMS")}
          title={t("nps_nps")}
          from={from}
          to={to}
          renderActionCustom={renderActionCustom}
          showFilterDate={show === "list" ? true : false}
          handleFilterDate={show === "list" ? this.handleFilterDate : ""}
        />
        {show === "chart" ? (
          <div>
            <Paper className={classes.root}>
              <Loading onRef={(id) => (this.loading = id)} />
              <ToolbarEmotion
                total={totalEmotion}
                changeEmotion={this.changeEmotion}
              />
              <Emotion data={dataEmotion} />
            </Paper>
            <Paper className={classes.root}>
              <Loading onRef={(id) => (this.loadingChart = id)} />
              <ToolbarChart
                total={totalInteract}
                changeChart={this.changeChart}
              />
              <div className={classes.container}>
                <Grid>
                  <SimpleLineChart data={dataChart} id="dashboard-orderchart" />
                </Grid>
              </div>
            </Paper>
          </div>
        ) : (
          <ListInteract
            onRef={(id) => (this.ListInteract = id)}
            interact={this.state.listInteract}
          />
        )}
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  npsDispatch: dispatch.nps,
  serviceBranchDispatch: dispatch.serviceBranch,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: 0 })(NPS)));
